module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="sorting-tabs">\n    <span data-sort="month">Last Updated</span>\n    <span data-sort="alphabetical">Alphabetical</span>\n    <span data-sort="person">Created By</span>\n    <span data-sort="state">Status</span>\n</div>\n<input class="content-filtering" type="search" placeholder="Search">\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/dashboard/DashboardSortingPanel.tpl
// module id = 2868
// module chunks = 0